exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ll-icon-close{width:14px;height:14px;opacity:.75;cursor:pointer;transition:opacity .15s cubic-bezier(0.23, 1, 0.32, 1)}.ll-icon-close:hover{opacity:1}", ""]);

// exports
